import type { DrivingLimitStatus, DrivingWeekLimits } from '../../../api/apiService';
import type { DriverLimits, DriverWorkState, DriverWorkStateSnapshot } from './types';

/** The three limits from the driver state responses. A missing part is null («Sem registo recente»). */
export const toDriverLimits = (
  rolling24h: DrivingLimitStatus | null | undefined,
  weekLimits: DrivingWeekLimits | null | undefined,
): DriverLimits => {
  const week = weekLimits?.week ?? null;
  const average = weekLimits?.average ?? null;
  return {
    rolling24h: rolling24h ?? null,
    week: week && {
      driven_seconds: week.driven_seconds,
      limit_seconds: week.limit_seconds,
      week_start: week.week_start,
      week_end: week.week_end,
      calculated_at: week.calculated_at,
    },
    fourMonth: average && {
      average_weekly_seconds: average.average_weekly_seconds,
      limit_weekly_seconds: average.limit_weekly_seconds,
      window_weeks: average.window_weeks,
      allowed_this_week_seconds: average.allowed_this_week_seconds,
      window_start: average.window_start,
      window_end: average.window_end,
      has_full_history: average.has_full_history,
      calculated_at: average.calculated_at,
    },
  };
};

export const toWorkState = (isSessionActive: boolean, isDriving: boolean): DriverWorkState =>
  isDriving ? 'driving' : isSessionActive ? 'available' : 'resting';

/** `since` is empty when the server has no records yet; the header then shows no timer. */
export const toWorkStateSnapshot = (
  isSessionActive: boolean,
  isDriving: boolean,
  stateSince: string | null | undefined,
): DriverWorkStateSnapshot => ({
  state: toWorkState(isSessionActive, isDriving),
  since: stateSince ?? '',
});
